import Descargas from "./pages/Descargas";
import Maestros from "./pages/Maestros";
import { Recuperar, NuevaPassword } from "./pages/RecuperarPassword";
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import AuthCallback from "./pages/AuthCallback";
import { AuthProvider, useAuth } from "./lib/auth";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/Upload";
import StudiesList from "./pages/StudiesList";
import StudyDetail from "./pages/StudyDetail";
import Compare from "./pages/Compare";
import AdminUsers from "./pages/AdminUsers";
import AdminLicencias from "./pages/AdminLicencias";
import AdminLeads from "./pages/AdminLeads";
import Informacion from "./pages/Informacion";
import FarmaClass from "./pages/FarmaClass";
import Activar from "./pages/Activar";
import Empleados from "./pages/Empleados";
import Perfil from "./pages/Perfil";
import Asistente from "./pages/Asistente";
import SuppliersList from "./pages/SuppliersList";
import SupplierDetail from "./pages/SupplierDetail";
import Laboratorios from "./pages/Laboratorios";
import MinMax from "./pages/MinMax";
import UploadFarmatic from "./pages/UploadFarmatic";
import SupplierOrder from "./pages/SupplierOrder";
import Reaprovisionamientos from "./pages/Reaprovisionamientos";
import Ventas from "./pages/Ventas";
import CuadroVentas from "./pages/CuadroVentas";
import IndicadoresStock from "./pages/IndicadoresStock";
import Informes from "./pages/Informes";
import StockParado from "./pages/StockParado";
import Consejo from "./pages/Consejo";
import Subidas from "./pages/Subidas";

function Protected() {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500"><Loader2 className="animate-spin mr-2" size={18} /> Cargando…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AdminOnly() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user || user.role !== "admin") return <Navigate to="/" replace />;
  return <Outlet />;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/activar" element={<Activar />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recuperar" element={<Recuperar />} />
          <Route path="/reset-password" element={<NuevaPassword />} />
          <Route path="/informacion" element={<Informacion />} />
          <Route element={<Protected />}>
            <Route element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="subidas" element={<Navigate to="/subidas/abcd" replace />} />
              <Route path="subidas/:view" element={<Subidas />} />
              <Route path="studies" element={<StudiesList />} />
              <Route path="studies/:id" element={<StudyDetail />} />
              <Route path="upload" element={<Upload />} />
              <Route path="upload/farmatic" element={<UploadFarmatic />} />
              <Route path="compare" element={<Compare />} />
              <Route path="labs" element={<Laboratorios />} />
              <Route path="labs/resumen" element={<Laboratorios />} />
              <Route path="labs/laboratorio" element={<Laboratorios />} />
              <Route path="min-max" element={<MinMax />} />
              <Route path="reaprovisionamientos" element={<Reaprovisionamientos />} />
              <Route path="ventas" element={<Ventas />} />
              <Route path="ventas/cuadro" element={<CuadroVentas />} />
              <Route path="indicadores/stock" element={<IndicadoresStock />} />
              <Route path="indicadores/ventas" element={<Navigate to="/ventas/cuadro#indicadores-ventas" replace />} />
              <Route path="equipo/informes" element={<Informes />} />
              <Route path="stock-parado/:view" element={<StockParado />} />
              <Route path="consejo" element={<Consejo />} />
              <Route path="consejo/empleados" element={<Navigate to="/empleados?tab=consejo" replace />} />
              <Route path="ventas/incentivos" element={<Navigate to="/empleados?tab=incentivos" replace />} />
              <Route path="empleados" element={<Empleados />} />
              <Route path="perfil" element={<Perfil />} />
              <Route path="asistente" element={<Asistente />} />
              <Route path="descargas" element={<Descargas />} />
              <Route path="maestros" element={<Maestros />} />
              <Route path="suppliers" element={<SuppliersList />} />
              <Route path="suppliers/:id" element={<SupplierDetail />} />
              <Route path="suppliers/:id/order" element={<SupplierOrder />} />
              <Route element={<AdminOnly />}>
                <Route path="admin/users" element={<AdminUsers />} />
                <Route path="admin/licencias" element={<AdminLicencias />} />
                <Route path="admin/solicitudes" element={<AdminLeads />} />
              </Route>
              <Route path="farmaclass" element={<FarmaClass />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-right" />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
